/*globals login*/
import React, { useRef, useState } from "react";
import styled from "styled-components";
import { useDimensions } from "common/hooks";
import BoxPlot from "common/BoxPlot";
import ThresholdModal from "../../../Subscriber&Groups/ThresholdModal";
import Threshold from "../../../Subscriber&Groups/Threshold";
import { getMetricsAttributes } from "../../../Subscriber&Groups/utils";

const Wrapper = styled.div`
  width: 100%;
  margin: 0 10px 20px;
  position: relative;
`;

const Title = styled.div`
  width: 100%;
  h5 {
    margin: 0;
    cursor: pointer;
  }
`;

const WrapperBoxPlot = styled.div`
  width: 100%;
  height: 155px;
  position: relative;
`;

const MARGIN = { top: 10, right: 10, bottom: 10, left: 20 };

const CenteredMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 100%;
  min-height: ${(props) => props.minHeight}px;
  width: ${(props) => (props.width ? props.width + "px" : "auto")};
`;

export const NoEnoughtData = ({ minHeight, width }) => (
  <CenteredMessage minHeight={minHeight} width={width}>
    Not enough data.
  </CenteredMessage>
);

const getThreshold = (threshold, quantileData) => {
  if (threshold === "MAX-Mbps") {
    return undefined;
  }
  if (threshold === "auto") {
    return quantileData.pcustom;
  }
  return threshold;
};

const SubscriberBoxPlot = ({
  metric,
  data,
  threshold,
  updateThresholds,
  colorize,
  quantileData
}) => {
  const [displayModal, setDisplayModal] = useState(false);
  const boxplotRef = useRef(null);
  const { width, height } = useDimensions(boxplotRef);
  const metricsAttributes = getMetricsAttributes(login);
  const {
    field,
    label,
    labelForModal,
    tooltip,
    inverted,
    units,
    legend,
    percentage,
    labelThreshold,
    unit,
  } = metricsAttributes[metric];
  const customThreshold = getThreshold(threshold, quantileData);

  return (
    <Wrapper>
      <Title>
        <h5 title={tooltip}>{label}</h5>
        <span>{legend}</span>
      </Title>
      {data.length === 0 ? (
        <NoEnoughtData minHeight={55} width={width} />
      ) : null}
      <WrapperBoxPlot ref={boxplotRef}>
        <BoxPlot
          data={data}
          width={width}
          height={height}
          margin={MARGIN}
          units={units}
          colorize={colorize}
          inverted={inverted}
          threshold={customThreshold}
        />
      </WrapperBoxPlot>
      <Threshold
        threshold={threshold}
        labelUnit={labelThreshold}
        setDisplayModal={setDisplayModal}
        inverted={inverted}
        customThreshold={customThreshold}
      />
      {displayModal ? (
        <ThresholdModal
          setDisplayModal={setDisplayModal}
          metric={field}
          unit={unit}
          label={label}
          labelForModal={labelForModal}
          threshold={threshold}
          updateThresholds={updateThresholds}
        />
      ) : null}
    </Wrapper>
  );
};

export default SubscriberBoxPlot;
